import { IVehicleMovementsState } from './vehicle-movements.state';
import { createReducer, on } from '@ngrx/store';
import {
  clearVehicleMovements,
  loadVehicleMovements,
  loadVehicleMovementsFailure,
  loadVehicleMovementsSuccess,
} from './vehicle-movements.actions';

export const initialState: IVehicleMovementsState = {
  vehicleMovements: null,
  loading: false,
  error: null,
};

export const vehicleMovementsReducer = createReducer(
  initialState,
  on(loadVehicleMovements, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadVehicleMovementsSuccess, (state, { vehicleMovements }) => ({
    ...state,
    vehicleMovements,
    loading: false,
    error: null,
  })),
  on(loadVehicleMovementsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(clearVehicleMovements, () => initialState)
);
